export class ScoreConstants {
  static readonly positiveHit = 'Positive Hit';
  static readonly anyHit = 'anyHit';
  static readonly allHit = 'allHit';
  static readonly uvPositiveScore = '+';
}
